import { Box, Grid } from '@mui/material';
import React from 'react';
import StatBox from 'components/StatBox';
import { Person2 } from '@mui/icons-material';
import { useGetEnquiryStatsQuery } from 'state/api';

const getTodayTimeRange = () => {
  const date = new Date()
  date.setHours(0)
  date.setMinutes(0)
  date.setSeconds(0)
  const today = date.getTime()
  // add miliseconds in one day: 24 * 60 * 60 * 1000
  const tomorrow = today + 86400_000
  return [today, tomorrow];
}

const Cards = ({ setFilters }) => {
  const { data, isLoading } = useGetEnquiryStatsQuery();

  return (
    <Box
      sx={{
        m: 2,
        ml: 0,
      }}
    >
      <Grid container spacing={4} className='flex justify-start'>
        <Grid item lg={3}>
          <StatBox
            className='text-white'
            title='Total Enquiries'
            value={isLoading ? '-' : data?.total}
            icon={<Person2 />}
            color='#1F509A'
            onClick={() => setFilters({})}
          />
        </Grid>
        <Grid item lg={3}>
          <StatBox
            className='text-white'
            title="Today's Enquiries"
            value={isLoading ? '-' : data?.today}
            icon={<Person2 />}
            color='#1F509A'
            onClick={() => {
              const [today, tomorrow] = getTodayTimeRange();
              setFilters({ from: today.toString(), to: tomorrow.toString() })
            }}
          />
        </Grid>
        <Grid item lg={3}>
          <StatBox
            className='text-[#1F509A] border border-[#1F509A]'
            title='Pending Followups'
            value={isLoading ? '-' : data?.pending}
            icon={<Person2 />}
            color='#D4EBF8'
            onClick={() => setFilters({ enquiryStatus: ['Ongoing'], pendingUntill: Date.now().toString() })}
          />
        </Grid>
        <Grid item lg={3}>
          <StatBox
            className='text-[#1F509A] border border-[#1F509A]'
            title="Today's Followups"
            value={isLoading ? '-' : data?.todayFollowUps}
            icon={<Person2 />}
            color='#D4EBF8'
            onClick={() => {
              const [today, tomorrow] = getTodayTimeRange();
              setFilters({ pending: today.toString(), pendingUntill: tomorrow.toString() })
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Cards;
